export default __webpack_public_path__ + "static/media/mail.bc4790a5.svg";